import React, { useState, useEffect, Suspense, lazy } from 'react';
import Modal from '../../../Components/Modal';
import {
    MDBTabsContent,
    MDBTabsPane,
    MDBRow,
    MDBCol
} from 'mdb-react-ui-kit';
import LoadingOverlay from '../../../Components/LoadingOverlay';

const ColumnSelector = lazy(() => import('./ColumnSelector'));

const tabConfig = [
    { name: 'columnSelector', icon: 'file-alt', label: 'Column Selector', component: ColumnSelector }
];

const MerlinModal = ({ isOpen, onClose, columns, selectedColumns, setSelectedColumns, portal }) => {
    const [activeTab, setActiveTab] = useState('columnSelector');
  
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    useEffect(() => {
        if (!isOpen) {
            setActiveTab('columnSelector');
        }
    }, [isOpen, columns, selectedColumns]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
            <Modal.Header>Table View</Modal.Header>
            <Modal.Body>
                <MDBRow>
                    <MDBCol size='12'>
                        <MDBTabsContent>
                            <Suspense fallback={<LoadingOverlay/>}>
                                {tabConfig.map(({ name, component: Component }) => (
                                    <MDBTabsPane key={name} open={activeTab === name}>
                                        <Component
                                            columns={columns}
                                            selectedColumns={selectedColumns}
                                            setSelectedColumns={setSelectedColumns}
                                            portal={portal}
                                            onClose={onClose}
                                        />
                                    </MDBTabsPane>
                                ))}
                            </Suspense>
                        </MDBTabsContent>
                    </MDBCol>
                </MDBRow>
            </Modal.Body>
        </Modal>
    );
};

export default MerlinModal;
